import { Routes, Route } from 'react-router-dom';
import { Authenticated } from './auth';
import { errorRoutes } from './error';
import { chatRoutes } from './chat';
import { webFormRoutes } from './webForm';
import { Logout } from './logout';
import { waitlistRoutes } from './waitlist';

export default function AppRoutes() {
  return (
    <Routes>
      <Route key="authenticated" element={<Authenticated />}>
        {chatRoutes}
        {webFormRoutes}
      </Route>
      {waitlistRoutes}
      {errorRoutes}
      <Route key="logout" path="/logout" element={<Logout />} />
    </Routes>
  );
}
